import React from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import PortContainer from './PortContainer.jsx';

const PortContainerList = (props) => {
  let notHiddenElemsCount = 0;
  return (
    <div>
      <fieldset id={props.portType}>
        {
          props
            .ports
            .map((elem, id) =>
              <div key={elem.get('id') || `port-${id}`}>
                {!elem.get('hidden') && notHiddenElemsCount > 0 ? <br /> : ''}
                <PortContainer
                  idx={id}
                  loadingPorts={props.loadingPorts}
                  dischargePorts={props.dischargePorts}
                  transport={props.transport}
                  ordinalId={notHiddenElemsCount++}
                  portType={props.portType}
                  disabled={props.disabled}
                />
              </div>
            )
        }
      </fieldset>
    </div>
  );
};
PortContainerList.propTypes = {
  ports: React.PropTypes.object,
  oppositePorts: React.PropTypes.object,
  portType: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  transport: React.PropTypes.object,
  loadingPortType: React.PropTypes.string,
  dischargePortType: React.PropTypes.string,
  loadingPorts: React.PropTypes.object,
  dischargePorts: React.PropTypes.object,
};

export default connect((state, props) => ({
  ports: state.getIn(['data', 'deals', 'ports', props.portType], new List()),
  loadingPorts: state.getIn(['data', 'deals', 'ports', props.loadingPortType], new List()),
  dischargePorts: state.getIn(['data', 'deals', 'ports', props.dischargePortType], new List()),
  transport: state.getIn(['data', 'deals', 'deal'], new Map()),
}))(PortContainerList);
